import config from '../config';
import category from './routes-category';

export const STUDENT_ROUTES = {
  DEFAULT: '/student/home',
  routes: [
    {
      category: category.student.STUDENTHOME,
      path: '/student/home',
      config: config.studentHome,
    },
    {
      category: category.student.TUTOR,
      path: '/student/tutor',
      config: config.student,
    },
    {
      category: category.student.TUTOR,
      path: '/student/test',
      config: config.studentTest,
    },
    {
      category: category.student.ASSESSMENT,
      path: '/student/assessment',
      config: config.assessment,
    },
    {
      category: category.student.AUDIOCONTROLS,
      path: null,
    },
    {
      category: category.student.INTERVENTION,
      path: null,
    },
    {
      category: category.student.HELP,
      path: '/student/help',
    },
    {
      category: category.student.LOGIN,
      path: null,
    },
    {
      category: category.student.REPORT,
      path: '/student/reports/:reportType/:reportId',
    },
    {
      category: category.student.RECOMMENDATION,
      path: '/student/recommendation',
    },
    {
      category: category.teacher.ACTIVITIES,
      path: '/teacher/activities',
      component: () =>  import('@/components/Teacher/StudentSearch'), //StudentSearch,
      config: config.teacher,
    },
    {
      category: category.teacher.GRADEBOOK,
      path: '/teacher/scoring/:activityId',
      component: () =>  import('@/components/Teacher/CorrectionManager'), // CorrectionManager,
      config: config.teacher,
      matchRouteWithSlots: function({activityId='1F8783C4D2ED11E89543168CA1AFEB4A'}){
        //activityId variable should match the name of the property sent from chatBot under slots
        //Inserting some dummy data as default to be safe
        return this.path.replace(':activityId', activityId);
      },
    },
    {
      category: category.teacher.REPORTS,
      path: '/teacher/reports/:reportType/:reportId',
      component: () =>  import('@/components/Student/NativeReports/NativeReports'), //NativeReports,
      config: config.teacher,
      matchRouteWithSlots: function({reportType='benchmark', reportId='12345'}){
        //reportType and reportId variables should match the name of the properties sent from chatBot under slots
        //Inserting some dummy data as default to be safe
        return this.path.replace(':reportType', reportType).replace(':reportId', reportId);
      },
    },
    {
      category: category.student.REPORTS,
      path: '/student/reports/:reportType/:reportId',
      component: () =>  import('@/components/Student/NativeReports/NativeReports'), //NativeReports,
      config: config.student,
      matchRouteWithSlots: function({reportType='progress', reportId='12345'}){
        //reportType and reportId variables should match the name of the properties sent from chatBot under slots
        //Inserting some dummy data as default to be safe
        return this.path.replace(':reportType', reportType).replace(':reportId', reportId);
      },
    },
  ],
};

export default STUDENT_ROUTES;